import React, { useState } from 'react';
import BackButtonPage from '../../../../../components/BackButtonPage';


function AttekintesAKorszakrol() {

    const [isVisible, setIsVisible] = useState(false);

    // Toggle the visibility when the link is clicked
    const handleToggle = () => {
        setIsVisible(prevState => !prevState);
    };

  return (
    <div className='page-content-container'>
    <p>
        A XVI. század elejének Magyar Királyságában járunk. 
        Fontos előzmény Hunyadi Mátyás haderőreformja, aki az európai súlyú Fekete Sereg mellett,
        egy 364 hadihajóból álló, erős Dunai flottává alakította a Nagy Lajos és Zsigmond által a 
        Dunai útvonal (mint az ország legszélesebb kapuja és hadiútja a törökök és a németek 
        felé egyaránt…) védelmében fenntartott flotillát. Ennek tagjai a királyi hajósnép (ebben 
        az időben kezdik őket Királynaszádosoknak nevezni), akik nem a korábbi banderiális 
        hadszervezet struktúrájában, hanem a zsoldos és a telekkatonai rendszer keverékének 
        formájában teljesítenek katonai szolgálatot. 
        Egy-egy kapitány, vagy vajda fősége alatt hajózó férfiemberek és családjaik alkotják azokat a 
        naszádos „kompániákat” (szláv ajkú hajósoknál druzsinákat), amelyek a közvetlen hajós 
        munkákból származó keresményeiket kereskedéssel, földműveléssel, állattartással, halászattal, 
        kézműves munkákkal, molnárkodással és számos egyéb tevékenységgel egészítik ki. 
    </p>
    <p>
        „Mátyás és II. Ulászló alatt Karancsy György és bizonyos Demeter voltak Pesten a 
        ’magistri nautarum’, a hajóvontató kompániának mesterei… A hajósok kompániája vagy 
        czéhe, mely az ország közlekedési fővonalait tartá kezében, magán üzérkedést is folytatott s 
        főleg gabonával és borral kereskedett… és czéhházánál tarja borraktárait.” 
        ( Szentkláray 329. old.)
    </p>
    <p>
        A hajósnép ezen kompániái kiválóan ismerik az ezidőtájt még szabályozatlan és állandó 
        mederrel el nem látott Dunát, és a szárazföldi kereskedőútvonalaknál sokszor gyorsabban, 
        nagyobb biztonsággal és nagyobb mennyiségben képesek szállítani a rájuk bízott árut. 
        Gabonát, sót, bort, gyümölcsöt, és minden egyebet szállítanak, amit a Duna-menti 
        nagykereskedelem igényel. De nem csupán a Duna habjait szelték kereskedő és hadihajók. 
        Természetes vízi országút volt a Tisza, és az összes kisebb mellékfolyó is. 
    </p>
    <p>
        <div>
            „Egyébként alig volt folyóvíz, melyen a XVI. és XVII. században hajók nem jártak volna! 
            A Duna mellékfolyóin: Traun, Inn, Ens, Morva, Vág, Garam. stb. folyókon ugyanazok a 
            hajók jártak, a melyek a Dunán s ugyanannyi terhet vittek, mint a Dunán. Ma e folyók 
            legnagyobb része hajózhatatlan lévén, szinte csodálkozunk, ha olvassuk, hogy a kis Traun
            folyócskán vagy nálunk a még kisebb Árva vizén meglehetősen megrakott hajók és szálak 
            (tutajok) közlekedhettek. Pedig a dolog magyarázata igen egyszerű. Az év bizonyos 
            időszakaiban minden folyó megdagadt, s ilyenkor mindegyikén lehetett hajózni. A régiek 
            úgy mondták ezt, hogy megérkezett a hajózás ideje! A télen át készült hajók százai a 
            mellékfolyókról ilyenkor szálltak a Dunára, ilyenkor indultak meg a gmundeni sókamara 
            sóhajói, a Traun folyó hatalmas dereglyéi, a Morva pallózott szálai. Vissza ezek közül 
            többnyire csak a sóhajókat vontatták, meg azokat a gabonával megterhelt hajókat, 
            melyek Tirol élelmét szállították. Ezek a hajók sokszor hónapokig vesztegeltek a Traun 
            vagy az Inn folyó torkánál, várván a nyári vagy őszi esőzéseket, melyek e folyócskákat 
            újra hajózhatóvá tették…
        </div>
        <div>
            A hajók túlnyomó része Bécsbe tartott, s az árúk majdnem kivétel nélkül a bécsi tárházakba 
            kerültek… A kereskedelmi városok, ha nem is estek közel a Dunához, szekereken 
            szállíttatták áruikat az első kikötőhelyig, s onnét már hajókon bocsátották alá. A hajóút 
            volt a legbiztosabb, legolcsóbb s legkényelmesebb…” 
            (DR. TAKATS SÁNDOR, A DUNAI HAJÓZÁS A XVI. ÉS XVII. SZÁZADBAN 106.-107. old)
        </div>
    </p>
    <p>
        <div>
            Békeidőben Bécs piacaitól és az osztrák kereskedőcéhek raktárházaitól, az aldunai török 
            fennhatóságú területekig oda-vissza szállították a magyar és a rác hajósok az árúkat (és a 
            híreket…). Állandó volt a konkurenciaharcuk a Bécsi hajóscéhekkel, akiknek hajói a török 
            betelepedése előtti időkben csak Budáig jártak. Nem úgy a magyar és rác hajósok:
            „Őket se a törvény nem gátolta se a félelem nem tartotta vissza, hogy török területre 
            hajózzanak. Gyalogszerrel vagy szekereken Bécsbe mentek, s hajókat vásárolván, a 
            legkelendőbb árúkkal megrakodva eveztek lefelé. A bécsi hajósok a magyarországi verseny 
            ellen hasztalanul védekeztek…
        </div>
        <div>
            …A XVI. és XVII. század legügyesebb és legmerészebb hajósai azonban kétségtelenül a 
            komáromiak voltak, akik nem törődve a Bécs érdekeit védő útkényszerrel, hajóikkal 
            Regensburgig is fölmentek, s megvetvén minden veszedelmet, áruikkal Drinápolyig, 
            Szarajevóig jártak. Az egész város lakói tisztán kereskedésből éltek, s még iparosai is 
            messze földre, a törökök közé vitték áruikat, s ott adták el…  A komáromi kereskedők 
            közül elsősorban a naszádosokat kell kiemelnünk. Ők ismerték legjobban a török 
            viszonyokat, s ők jártak leggyakrabban török földön. Aczélizmú, bátor hajósnép volt ez; 
            föl és le egyforma erővel hajtotta hajóját és sohasem szorult vontatókra. Békében és 
            háborúban egyaránt kereskedett, s mikor más kereskedő kimozdulni sem mert házából, 
            a naszádos félelem nélkül ült hajójára, s a nagy kereslet miatt rendesen dupla haszonnal 
            tért vissza. Bátran kérdhetné valaki, miként volt lehetséges, hogy egy tisztán katonai 
            intézmény tagjai ilyen mértékben űzték e polgári foglalatosságot? A felelet könnyű és 
            egyszerű, mert a naszádosok első sorban kereskedők, halászok, iparosok vagy földművesek 
            voltak. A naszádos vajdák idejük nagy részét malmaikban töltötték, vagy kereskedtek; a 
            köznaszádosok pedig szőttek, csizmát varrtak, halásztak, s nyáron át csapatosan mentek 
            az aratásra… Jóravaló polgárok voltak mindannyian; a vajdák ott ülnek a városi 
            tanácsban, s nem egyszer a bírói székben is…  A naszádosok csak a háborúban voltak 
            igazi katonák… Meg kell jegyeznünk, hogy a komáromi naszádos nép nyelvre és szellemre 
            magyar volt, s ami idegen került közé, néhány év alatt az is teljesen megmagyarosodott... 
            A komáromiakon kívül csak a rácz kereskedőkről mondhatjuk még el, hogy Belgrádtól 
            Bécsig minden helyet, fölkerestek hajóikkal. Jó kereskedőknek, de elsőrangú csempészeknek 
            tartották őket mindenkor.” (Takáts 108-112. old.)
        </div>
    </p>
    <p>
        <div>
            Dr. Szentkláray Jenő, a Dunai hajóhadak c. művében így ír a naszádos közösségekről: 
            „A magyarországi hajóhad alapszervezetét kezdettől fogva a családegység, vagyis a társas 
            együvétartozás elve képezte. A zsoldos had, mely a folyami végházak környékén a király 
            által adományozott hajós telkeken települt, önmaga közt egy szabad, s a czímeres nemesi 
            rend szabályaihoz hasonló kiváltságokkal felruházott katonai társaságot képezett, melynek 
            fejei a kapitány és a vajdák, később az osztrák hadi kormány alatt a parancsnokok, tagjai 
            pedig mindazon ténylegesen szolgáló, vagy ezeknek házi gazdaságát gondozó hajónép 
            vala, mely a király felhívására, megszabott heti vagy hópénzért és egyéb járulékokért 
            bármikor fölkelni és vizen harczolni tartozott.” (304. old.)
        </div>
        <div>
            „A királyi hajósnép… Mátyás alatt lett az valóságos katonai intézménnyé… Ekkor lesz a 
            német mintára naszádokkal fölszerelt királyi dunai hajósokból, a dunai telekkatonaságból 
            királynaszádos had… Lényegében változatlan marad, telkeit, réveit és szabadságait 
            megtartja, de beillesztetik… az Anjouk alatt pedig nálunk is mindjobban megerősödött 
            olaszos condottiere zsoldrendszerbe. Magyarországon úgy, mint a többi Európában, 
            nagyon elharapózott a „soldiarii”-k szervezete. Zsoldos nép nem csak a született 
            magyarok közül szegődött a királyi zászlók alá, hanem bármely nemzetiségű bennszülöttek 
            vagy külföldiek készséggel állottak be a király seregébe jó zsoldért… 
        </div>
        <div>
            A különböző eredetű hadi népek ezen egyvelegében a hazafiság szelleme, a kötelességérzet, 
            s a fegyelem tartá fen a szükséges egységet. Mátyás szívesen vett be hadaiba idegen 
            harczos csapatokat, a minthogy ben a hazában sem vonhatá ki senki magát a honvédelem 
            kötelessége alól, ha származására nézve nem is volt éppen magyar.”(61. old.)
        </div>
    </p>
    <p>
        <div>
            Csonkaréti Károly, Hadihajók a Dunán című művében egyenesen a Fekete Sereg folyami 
            megfelelőjének nevezi ezt a haderőnemet:
        </div>
        <div>
            „A Királynaszádos had a közismerten fekete seregként emlegetett szárazföldi zsoldos 
            hadnak volt a folyami megfelelője. Csakhogy a fekete sereget II. Ulászló (1490-1516) már 
            nem tudta fizetni. Szétszéledtek, vagy rablásból tartották fenn magukat, s maradványaikat 
            Kinizsi Pál verte szét. A naszádosok azonban együtt maradtak, a király ugyanis a zsoldon 
            felül földbirtokot is adományozott nekik, s így nem voltak annyira a zsoldra utalva 
            – kiszolgáltatva- mint a „feketék”. Pénz nélkül is tovább szolgáltak” (38.old.)
        </div>
        <div>
            „A király hadjáratai során már uralkodásának első éveitől kezdve igénybe vette a hajóhadat, 
            s elsősorban a határvédelemnél alkalmazta. Létszámát, hajóállományát a török elől 
            menekülő szerbekkel – a magyarok rácoknak nevezték őket – bővítette. A szerbek közt 
            sok hajós akadt. A török ugyanúgy ellenségük volt, mint nekünk, hiszen az oszmán 
            hatalom éppen Mátyás uralomra jutásának évében kezdett az addig is állandó dúlásnak 
            kitett országban berendezkedni. Az edzett, hadakozásban jártas katonanépet a magyar 
            király felhasználta, s a Duna menti támaszpontokon elhelyezést, zsoldot, sőt földet is 
            kaptak. Ennek fejében a magyar vízi haddal együtt, esetenként önállóan is küzdöttek… 
            Amikor Mátyás hadserege és vele hajóhada is északon, Ausztriában Csehországban 
            harcolt, a déli végeken a szerb hajósok látták el a határ védelmét.” (28. old.)
        </div>
    </p>
    <p>
        <div>
            Antonio Bonfini, Mátyás uralkodása alatt Magyarországon tevékenykedő itáliai 
            humanista történetíró így méltatja A magyar történelem tizedei (Rervm Vngaricarvm 
            Decades) című művében a királyi hadat:
        </div>
        <div>
            „De ha meggondolom a katonai fegyelmet, azon szent erkölcsöket, melyekkel Mátyás 
            az ő magyar vitézeit nevelte, nem csekélyebb bámulatra ragadtatom. Egy nemzetnél 
            sem találni olyan katonákat, kik a meleget és a hideget, munkát és fáradtságot annyira 
            elviselni tudnák, a parancsolatot szívesebben teljesítenék, az adott jelre örömestebb 
            mennének a csatába és halálba, a katonai lázadástól jobban írtóznának, a táborban 
            békességesebben, tisztességesebben élnének, vallásosabbak lennének s a zajongásokat és 
            veszekedést jobban kerűlnék, a mértékletességet és nemi tisztaságot jobban gyakorolnák, 
            a káromkodástól, hamis eskütől és fajtalanságtól jobban félnének mint Mátyás katonái. 
            Vitézebbek és kitartóbbak a lacedaemonoknál is.” (Bonfini: Decad. IV. L. VIII.)
        </div>
    </p>
    <p>
        „Amikor Mátyás Bécsben meghalt, holttestét díszesen felravatalozott hadihajók szállították 
        Budára. A gyászmenet 50 fekete lepelbe burkolt hajóból állott. A végtisztességet a 
        királynaszádosok hajóhada adta meg. Ez a flotta szépen megmunkált, díszes kivitelű 
        egységekből állt.” (Csonkaréti, Hadihajók a Dunán 31. old.) 
    </p>
    <p>
        A Dunai hajóhadat felvirágoztató Mátyás királyt 1490-ben II. Ulászló váltotta a trónon.
    </p>
    <div className='zold-kiemeles-container'>
        <a 
            className="zold-kiemeles" 
            href="#!" 
            onClick={handleToggle} 
            style={{ cursor: 'pointer' }}
        >
            II. Ulászló életútját és uralkodását bemutató összefoglaló. A Magyar Királyság akkori 
            viszonyaira is rávilágító részletek a wikipédiából
        </a>

        {/* Conditionally render the iframe based on the isVisible state */}
        {isVisible && (
            <iframe 
                src="https://hu.wikipedia.org/wiki/II._Ul%C3%A1szl%C3%B3_magyar_kir%C3%A1ly"
                width="100%" 
                height="500" 
                style={{ border: 'none', marginTop: '10px' }}
                title="II. Ulászló Wikipedia"
            />
        )}
    </div>
    <p>
        <div>
            A királynaszádosokra és a hajóhadra nézve is nehéz idők következtek. A pártviszályokba 
            és belső háborúkba merült országvezetés nem volt képes egyben tartani a folyami 
            hajóhadat. Így ír erről Szentkláray:
        </div>
        <div>
            „Alig, hogy Mátyás behunyta szemeit, a haza minden ügyében átkos hanyatlás következett 
            be… Hajórajunk egy osztálya még Ausztriában vesztegelt az elfoglalva tartott várak alatt, 
            csüggetegen tekintve bizonytalan sorsa felé. Némelyek megadják magokat a trónkövetelő 
            Maximilian vezéreinek, és szép igéretek által elcsábítva, a római király szolgálatába 
            szegődnek. Az itthon maradtakat magokhoz vonják a királyválasztási viszályokban 
            egymást mardosó, zsákmányért és hatalomért egymást közt versengő országnagyok. 
            Némelyek közülük Corvin Jánost uralják, mások az özvegy királynéhoz szítanak, a szerint, 
            a mint itt vagy amott kecsegtetőbb kilátás nyílik zsoldjavításra… A naszádosokat most is 
            király-naszádosoknak nevezik, de ők magok nem tudják, hogy ki a királyuk.” (74. old.)
        </div>
    </p>
    <p>
        A trónért való küzdelemben végül a Jagelló házi II. Ulászló lett a győztes. A 
        királynaszádosok tevékenysége az 1492-1495. évi török elleni harcokban főképp 
        Nándorfehérvár megerősítésére és seregeinknek a Dunán való átszállítására terjedt ki. 
        A déli végek biztosítására tett királyi és főúri intézkedések 1498 körül már azt 
        eredményezték, hogy Nándorfehérvár, Zalánkemén, Pétervárad és a Száva parti Szabács 
        megerősített állomáshelyei lettek a naszádosoknak. 1504-ben ez 1100 naszádos katonát 
        jelentett a térségben. Voltak azon kívül egyes délvidéki révbirtokos nemesek is, mint 
        Sankó Miklós, Bánmonostor ura, kik saját embereikkel és tulajdon hajóikon őrizték az 
        Al-Dunát a törökök betörése ellen.  (Szentkláray 76. old. és Csonkaréti 40. old.) 
    </p>
    <p>
        <div>
            Délmagyarország szerbjei fölött 1505-től Silyánovics István despota vezérkedett, akinek 
            Ulászlótól kapott feladata volt az Al-Dunai naszádhad fegyverben tartása és az ottani 
            révek ellenőrzése. Ezt eleinte sikerrel és hűen végezte, amit a király földbirtokok és 
            Siklós várának nekiadományozásával hálált meg. Silyánovics hűsége 1514-1515-ig tartott, 
            amikor a Dózsa féle belháborúba torkolló kereszteshad-állítás zavaros viszonyait 
            kihasználva, megpróbálta függetleníteni magát a magyar korona felsőbbsége alól és 
            önálló tartományt szándékozott kikerekíteni magának Magyarország déli végeiből. 
            Újfent megosztva ezzel a királynaszádos hadat.
        </div>
        <div>
            Lázadásának leverése és felnégyeléssel való megbüntetése után „A király Szerém- és Bács 
            megyék leggazdagabb és legmegbízhatóbb birtokos családjának, egy vitézi erényekben 
            és képzettségben egyaránt jeleskedő sarjára, Révai Istvánra bízta most összes dunai 
            hajóhadát, kapitánnyá nevezvén ki őt naszádos seregéhez. Révay István 1511 óta szolgált 
            a király naszádjain mint vajda, és sem a végek oltalmazásánál, sem az utóbbi 
            pórlázadásban nem tántorodott el a király hűségétől, sőt ő verte s ölte meg kevesed 
            magával azt a híres zvorniki basát, Aszam béget…  valaminthogy a Silyánovics 
            leveretésénél és a péterváradi és zalánkeméni hajóraj megmentésénél is ő érdemelte ki 
            leginkább fejedelme tetszését… Révai István nagy szerencsétlenségek előestéjén vette át 
            a magyar dunai flottát….  (Szentkláray 78-79. old.) 
        </div>
    </p>
    <p>
        II. Ulászló után fia, II. Lajos kerül a trónra. 
    </p>
    <div className='zold-kiemeles-container'>
        <a 
            className="zold-kiemeles" 
            href="#!" 
            onClick={handleToggle} 
            style={{ cursor: 'pointer' }}
        >
            Életútját és uralkodását bemutató összefoglaló. A Magyar Királyság akkori viszonyaira 
            is rávilágító részletek a wikipédiából
        </a>

        {/* Conditionally render the iframe based on the isVisible state */}
        {isVisible && (
            <iframe 
                src="https://hu.wikipedia.org/wiki/II._Lajos_magyar_kir%C3%A1ly"
                width="100%" 
                height="500" 
                style={{ border: 'none', marginTop: '10px' }}
                title="II. Ulászló Wikipedia"
            />
        )}
    </div>
    <p>
        <div>
            A Mohácsi csatát közvetlenül megelő években mindenfelől szorongattatás és bizonytalanság 
            volt jellemző az országban. Az Európai nagypolitika a gyarmatosítás lázában égett, a 
            Közép Európai államok elvesztették gazdasági jelentőségüket. A nagypolitika valódi 
            formálói a pénzarisztokrácia fejei. A Cseh, a Magyar és a Német Római uralkodók és 
            országaik a Fuggerek bankárainak igáját nyögik. A Magyar királyságra, mint 
            kiszipolyozható gyarmatra tekintenek és főként a kereskedelem, az ezüst, az arany és a 
            sóbányák hasznát szedik, de minden üzletre, az akkori élet minden területére igyekeznek 
            rátenni a kezüket. A Magyar Királyságban a Fuggerek egy hispániából elűzött zsidó 
            bankárcsalád fején, Fortunatus Imrén (eredeti nevén Salamon ben Efraim) keresztül 
            érvényesítették az akaratukat és az érdekeiket. Politikai nyomásgyakorlásaikkal és ügyes 
            kölcsöneikkel addig mestrekedtek, amíg a nevezett bankárt 1520-ban alkincstartóvá tette 
            a király. 
        </div>
        <div>
            Működése során a hivatalos magyar pénznem a dénár elértéktelenedett. Már 1521-ben, 
            Nándorfehérvár eleste alkalmával a Szapolyai-párti köznemesek azzal vádolták Fortunatust, 
            hogy hanyagságból és rosszakaratból a felmentéshez szükséges pénzt és fegyvereket későn 
            indította útnak. Fortunatus tanácsára verette a király azt a hamis pénzt, melynek valódi 
            értéke csak fele része volt a névleges értéknek. 1525. május 7-én tartott budai 
            országgyűlésen a nemesség Fortunatust a királyi jövedelmek hűtlen kezelésével vádolták. 
            A király, engedve a nemeseknek, Fortunatus Imrét  a budai Csonkatoronyba záratta, 
            ahol egy hónapig raboskodott. Fortunatus a Fugger család rokonának, Thurzó Eleknek 
            (körmöci kamarai gróf, majd főkincstárnok, 1523-1525 között) helyetteseként Mária 
            királyné legszűkebb bizalmi köréhez tartozott, aki, mihelyst az országgyűlés szétoszlott, 
            parancsot adott az alkincstartó szabadon bocsátására… Hamarosan helyreállította 
            anyagi helyzetét; 1525 végén már ő bérelte a budai, 1526-ban pedig a pozsonyi 
            harmincadot is. 
        </div>
        <div>
            Annak érzékeltetésére, hogy miért volt ez katasztrofális súlyú csapás a korszak Magyar 
            Királyságára, arra jól rávilágít, hogy a középkor végén a törvényes zsidókamat heti 2% 
            volt. Amennyiben az adós nem fizette meg határidőre adósságát, azután kétszeresével, 
            majd újabb határidő elmulasztása esetén annak kétszeresével - és így tovább - tartozott. 
            Ha II. Lajos 1525. január 1-én száz aranyat kapott kölcsön Fortunatus Imrétől, 1526. 
            január 1-én ezernégyszáz aranyat kellett visszafizetnie. Az alkincstárnok 1526 nyarán már 
            nem adott kölcsönt a királyának, pont rosszkor, mert a szultán hadjárata miatt se pénz, 
            se hadsereg nem volt, ezért Lajos ezüst étkészletét zálogosította el.
        </div>
        <div>
            Ne felejtsük el, hogy ezek a szörnyű, zavaros esztendők már közvetlenül a Mohácsi csatát 
            megelőző évek. A magyar nemesség pártoskodásokban és belviszályokban megosztott. 
            A  bankárházak mesterkedései mellett két korabeli szuperhatalom, a Török Birodalom és 
            a Német-Római Császárszág bekebelező szándéka is harapófogóban tartja országunkat.
        </div>
    </p>
    <p>
        <div>
            Lássuk, hogy hogyan alakul ezekben a vészterhes időkben a királynaszádosok sora. Dr. 
            Csonkaréti Károly, a kiváló hadtörténész, alább közölt írásban plasztikus képet fest a 
            korszak hadihajós viszonyairól:
        </div>
        <div>
            „A naszádos had összlétszáma is mindig az adott körülményektől függött: a hadjáratok 
            idején az uralkodók igyekeztek felduzzasztani…. 1504-ben Nándorfehérvárott és 
            Zalánkeménben ötszáz-ötszáz, Szabácson pedig 10 főnyi naszádos katona állomásozott. 
            Az 1521. évi hadjáratban, amikor Nándorfehérvár és Zimony alatt az utolsó csatákat 
            vívták, ötszázan voltak. Pétervárad 1523. évi védelmében TOMORI PÁL kalocsai érsek 
            számukat ezer főre duzzasztotta, és – mivel a török hajóhadát szétverték – sikerült is 
            megakadályozni a vár elestét…
        </div>
        <div>
            Támaszpontjaik – a török előnyomulástól függően – kezdetben Nándorfehérvárott, 
            Szendrő alatt voltak. Ezután Zimony, Pétervárad és Zalánkemén voltak a bázisok. Buda, 
            Esztergom és Pozsony – amíg a két első török kézre nem került – szintén naszádos 
            állomáshelyek. Az al-dunai szakasz elvesztése után Vörösmart, Ráckeve és Vác voltak a 
            fontosabb állomáshelyek…
        </div>
        <div>
            Ma már nem könnyű megállapítani, Hogy a hajóállományuk mekkora volt…
            A Mohácsot közvetlenül megelőző időben 1526-ban, Pétervárad elesténél TOMORI 40 
            naszáddal harcolt. Ez a kis flotta a mohácsi csatavesztés napjára még nyolc egységgel 
            kiegészült. Ekkor ezeken a fegyveres hajókon kívül Mohács és Szekcső térségében még 
            40-50 egyéb dereglye, ladik horgonyzott, s a vesztett ütközet hírére, menekülőkkel 
            megrakva, lóhalálban eveztek Buda felé. Budáról azután 76 különféle hajó vitte a 
            menekülőket Pozsony felé.
        </div>
        <div>
            A mohácsi csatavesztés napján a naszádosok parancsnoka RADISA BOSICS volt. 
            A következő esztendőben már 70 naszád horgonyzott harcra készen Komáromban 
            I. Ferdinánd támogatására, fedélzetén kétezer naszádossal…
        </div>
        <div>
            Mint már utaltunk rá, a királynaszádosok állandóan, mégpedig fizetésért szolgáló, mai 
            szóval élve hivatásos katonák voltak. Hazánkban Mátyás király volt az első uralkodó, 
            aki állandóan fegyverben tartott, fizetésért (zsoldért) szolgáló hadsereget állított fel, s 
            ennek keretében szervezte meg vízi haderejét is. Igaz, hogy a királyok és oligarchák már 
            korábban is tartottak környezetükben néhány száz fizetésért szolgáló vitézt, de ezek 
            inkább amolyan testőrszerepet töltöttek be, s az ország védelme szempontjából nem 
            volt jelentőségük.
        </div>
        <div>
            A királynaszádosok zsoldjáról az első értesüléseink a XV. század végéről származnak. 
            Ekkor egy naszádos évi 2-3 három forintért, sóért és ruházatra való sötétkék posztóért 
            továbbá bizonyos telekért szolgált. A vajdák ugyanekkor évi 25 forintot és ugyanilyen 
            értékű sót kaptak.
        </div>
        <div>
            A királynaszádosok fizetése körülbelül olyan összeg volt, mint amilyent a királyi várakban 
            szolgáló könnyűlovasok – huszárok – kaptak, megtoldva a földdel, amelyen gazdálkodtak, 
            s amely után adót nem fizettek.
        </div>
        <div>
            Bár a külön szolgálatokért kapott extra pénzeket – már akkor is „borravalónak”, „pro 
            bibibus” nevezték – nem számíthatjuk hozzá jövedelmükhöz, mégis megemlítjük, hogy 
            ilyen is létezett. Példa erre, hogy a pécsi püspök, egy személyben tárnokmester 
            (pénzügyminiszter) 1494-ben a péterváradi naszádos legénységnek 1 forintot, a 
            Nándorfehérváriaknak pedig 8 forintot utalványozott a kincstárból borravaló címén 
            – vagy talán a szebben hangzó prémiumként – a török háborúkban kifejtett vitézségük 
            jutalmazására.
        </div>
        <div>
            A bizalmas futárfeladat szintén a naszádosok külön premizált szolgálataihoz tartoztak. 
            Ezen nem csodálkozhatunk, mert akkoriban az utakon a közbiztonság igen rossz volt. 
            Az útonállóknak, a haramiáknak, esetleg a politikai érdekcsoportok bérenceinek 
            erőszakos támadásai úgyszólván napirenden voltak, s nemegyszer az ilyen fegyveres 
            rajtaütéseket maguk a főurak, országos méltóságok viselői vezették. Így a 
            legbiztonságosabb közlekedési útvonalak a Duna és a többi folyók voltak. Ezért nem 
            volt ritka eset, hogy a naszádosok egy-egy vajda parancsnoksága alatt a király levelével 
            eveztek egyik helyről a másikra. Ezt a futárszolgálatot külön jutalmazták. Amikor Tomori 
            érsek 300 gyalogost szállított Budáról 1525-ben Péterváradra, a tárnokmester a 
            szállítóhajók négy kormányosának 44 forintot utalt ki. 
        </div>
        <div>
            A naszádosoknál ugyanúgy, mint a szárazföldi hadseregnél várostromok, vagy 
            várvédelmek alkalmával – ha volt miből – külön ostrompénzt is kiutaltak. 
        </div>
        <div>
            Ha volt miből! Mert, amikor a Jagellók alatt a kincstár ugyancsak kimerült, elmaradtak 
            a borravalók, sőt még a zsold is. 
        </div>
        <div>
            Két ilyen – zendüléssel végződő – esetről tudunk a Jagellók idejéből. Az egyik 1521-ben 
            történt.
        </div>
        <div>
            A nándorfehérvári, a zimonyi és a zalánkeméni naszádosok ekkor már harmadik 
            esztendeje hiába várták a zsoldjukat. Küldöttséget menesztettek a királyhoz, aki 
            utasította VÁRDAI PÁL kincstartót a hátralék kifizetésére. De ő – mivel a kincstár üres 
            volt – nem fizetett semmit. A küldöttség erre vissza akart menni II. Lajoshoz, hogy 
            panaszt tegyen, de nem bocsátották őket a király elébe. A vérig sértett és feldühödött 
            naszádosok erre – SZERÉMI GYÖRGY udvari káplán, krónikaíró szavai szerint
            – „Zászlajukat azonban kikötötték a budai vár kapuja elé. Pedig azt mondhatom, uraim,
            hogy a törökök császárának nem voltak ilyen emberei a Duna folyón, mint a magyar 
            királynak. És a naszádosok lefutottak hajóikhoz, s amit mindkét parton rabolhattak, 
            elrabolták. 
        </div>
        <div>
            Egy hónap múlva ismét eljöttek Lajos királyhoz. Ő szívesen adott volna nekik, ezt láttam, 
            de jövedelmét egészen a mágnások kezelték… És ily módon a naszádosokat megint Pál 
            prépost kincstartóhoz irányították. Hogy a nevezett lator, kincstartó az alfelét kitörölte 
            a papírral, ismét az arcukba dobta. Szóltak ugyanolyan módon, mint fentebb írtuk: Mi 
            többé nem szolgálhatunk a királyi felségnek. Ez már a vég. Magyarország, az Úristen 
            legyen veled! – s a királyi felség két zászlaját a kezükben hozták s erősen megkötötték a 
            kúthoz. Tüstént leesett a földre a két zászló… Gyorsan leszaladtak a naszádosok a 
            hajókhoz a Duna folyóra, leeveztek szegények s többé nem jelentek meg…”
        </div>
        <div>
            Néhány héttel ez eset után a törökök elfoglalták Nándorfehérvárt, mert a víz felől, ahol 
            a bástyák gyengébbek voltak, a naszádosok nem oltalmazták a várat. „…Végül szívesen 
            fizettek volna nekik, de nem volt kinek…” – jegyzi meg keserűen krónikájában Szerémi 
            György. A naszádosok ugyanis szétszéledtek. Alig ötszázan maradtak csak helyükön. 
            S ez a létszám a török flotta ellenében kevésnek bizonyult.
        </div>
        <div>
            Nándorfehérvár stratégiai szerepét Pétervárad vette át. Nagy volt az ijedelem Budán és 
            az egész országban. Az elszéledt naszádosokat vissza kellett csalogatni s valahonnan 
            pénzt teremteni a számukra. Számukat a következő években sikerült is újból ezerre 
            emelni.
        </div>
        <div>
            Az 1523. évből két költségvetési előirányzat maradt fenn számunkra. Az egyiket 
            áprilisban THURZÓ ELEK, a Várdait követő kincstartó készítette. A kiadások rovatban 
            ezer naszádos részére 24 ezer forintot irányzott elő, s azt ők megkapták. Megemlítjük, 
            hogy ugyanebben a költségvetési előirányzatban csupán Jajca és Horvátország kapott 
            többet, mint az ezer naszádos.
        </div>
        <div>
            Thurzót szeptemberben leváltották, helyét ismét Várdai vette át, aki ekkor már 
            Veszprém püspöke volt. Ő decemberben készített egy költségvetési előirányzatot, amely 
            már csökkentette a kiadási összegeket, de az ezer naszádosnak még így is 18 ezer forintot 
            szántak.
        </div>
        <div>
            A török veszély látszólagos elmúltával a katonák pénze ismét máshova került. 
            Természetesen a naszádosoké is. Ezért NESTHE LUKÁCS, NAGY PÉTER, HEVESSY ISTVÁN 
            és RÁCZ PÉTER péterváradi naszádos vajdák 1525-ben kénytelenek voltak ezer 
            közemberük érdekében és képviseletében Budára utazni az elmaradt fizetésért. 
            Hosszadalmas kilincselés után végül is a kincstárból leszámoltak Nesthééknek 1500 
            forintot a köznaszádosok, 100 forintot pedig a vajdák és a tizedesek részére. 
            A hadsegédek kezéhez 800 forintot fizettek ki. Ekkor a jajcai naszádosok zsoldhátraléka 
            is már 4000 forintra rúgott. 
        </div>
        <div>
            A péterváradiak nyilván csak valami előleget kaphattak a hátralékuk fejében; hogy az 
            egész követelés mennyit tett ki, nem tudjuk, mert ugyanebben az évben (1525) a 
            jajcaiakkal együtt ismét megjelentek Budán.
        </div>
        <div>
            A naszádosok követelőzve addig maradtak ott, amíg csak valamennyi pénz a kincstárba 
            befolyt, s abból a péterváradi legénység részére 4000, vajdáik számára 135 és a 
            tizedeseiknek 200 200 forintot kiosztottak. 
        </div>
        <div>
            Nem sokkal ez után a zalánkeméni naszádosok öt vajdája rimánkodott az elmaradt 
            ellátmányért: ZALÁNKEMÉNI BERTALAN, LÁSZLÓ PÉTER, ZUGORICHA JÁNOS, 
            FEJÉRVÁRI BALÁZS és ZEMPLÉNYI JÁNOS. Hogy milyen eredménnyel, nem tudjuk.
            Mint látjuk, akkoriban minden katonának, néhány évtizeddel később pedig a végvári 
            vitézeknek, meg kellett küzdeniük a járandóságukért. Ez nagy elkeseredést szült a 
            veszélyeztetett déli végeket védelmező királynaszádosok körében… Jószerivel 
            kijelenthetjük, hogy csupán TOMORI PÁL érsek fordította minden jövedelmét  
            - a kalocsai érsekségét, a bácsi püspökségét és a főkapitányit – az országhatár 
            megerősítésére, katonák toborzására és fegyverben tartására. De ez kevés volt. 
            A kincstár csak hosszabb könyörgésére utalt ki neki 49 forintot a kiöregedett naszádok 
            javítására, és 32 forintot négy új naszád vásárlására. Ebből kitűnik, hogy egy új naszád 
            építése ebben az időben 8 forintba került. 
        </div>
        <div>
            A kincstár 1525 nyarától 1526 márciusáig egy fillért sem fizetett a naszádosoknak, mire 
            sokan közülük elhagyták a hajókat és más munkát vállaltak, hogy családjuk megélhetését 
            biztosítsák. Erre az időre zsoldhátralékuk már 40 ezer forintra emelkedett. Ugyanekkor 
            II. SZOLIMÁN Nándorfehérvárott, IBRAHIM nagyvezír pedig a Szávánál állt seregével. 
            TOMORI a határvédelem helyzetéről kétségbeesett jelentést írt a királynak: 
            „…A naszádosoknak már hosszabb idő óta állandóan a hajókon kell lenniük, de nincs 
            ennivalójuk. Ha felséged nem fogja őket ezentúl hetenként fizetni, egytől egyik 
            mindannyian itthagynak. Mert az éhezést nem bírják már tovább elviselni. Ha ez 
            megtörténnék, a török vízi ereje akadálytalanul és szabadon úszhat föl a Dunán. Amit 
            felséged a minapában énáltalam küldött el nekik (20000 forintot és 5000 forint értékű 
            posztót), azt azonnal adóságaik törlesztésére fordították. Azt pedig jól tudja felséged, 
            hogy régebbi zsoldjaik is még hátralékban vannak. Most nem várhat a naszádos 
            legénység az illetékeire, mint máskor. Máskor dologra, aratásra vagy favágásra 
            bocsátottam szét őket, és volt egy kevés keresetük, amiből élelmüket megszerezhették. 
            Azonban most az ilyesmi nem lehetséges…”
        </div>
        <div>
            Mire a török megkezdte pétervárad ostromát, Tomorinak sikerült 1000 főre gyarapítania 
            a hajóhad legénységét, s harcba is vetette őket. ennek során néhány török hajót és egy 
            gályát elsüllyesztettek. Később mégis ki kellett vonni őket a harcból, mert az a 
            naszádosok számára – a siker legkisebb reménye nélkül -  a biztos megsemmisülést 
            hozta volna. Ugyan mit árthattak volna a királynaszádosok a 40 naszádjukkal a 800 
            egységből álló török tengeri-folyami flottának?... 
        </div>
        <div>
            Pétervárad a török kezébe került. és egy hónap múlva bekövetkezett a mohácsi 
            katasztrófa.”  
        </div>
    </p>
    <p>
        <div>
            A királyi had vonulásáról és a Mohácsi csatasíkon történtekről egy kincset érő forrásunk 
            van. Brodarics István kancellár, szerémi püspök résztvevője volt a csatának és fél év 
            múlva Krakkóban a történtekről pontos és hiteles emlékiratot, igaz leírást készített 
            Zsigmond lengyel királynak. Munkájának az „Igaz leírás A magyaroknak a törökökkel 
            Mohácsnál vívott csatájáról” címet adta.
        </div>
        <div>
            Ezt a leírást, a hozzá tartozó előszókkal és jegyzetekkel egyetemben, az alábbi internetes 
            oldalon olvashatjuk:
        </div>
    </p>

    <a 
        className="zold-kiemeles" 
        href="https://mek.oszk.hu/05800/05872/html/index.htm" 
        target="_blank" 
        rel="noopener noreferrer"
    >
    https://mek.oszk.hu/05800/05872/html/index.htm
    </a>

      <BackButtonPage to="/ter-segedlet" />
    </div>
  );
}

export default AttekintesAKorszakrol;
